module.exports = __webpack_public_path__ + "img/yw_wfgl.57062516.svg";